export enum Roles {
	GRAPHICS_DOCUMENT = "graphics-document",
	GRAPHICS_OBJECT = "graphics-object",
	GRAPHICS_SYMBOL = "graphics-symbol",
	GROUP = "group"
}
